module.exports = "\r\nej-reportviewer {\r\n  display: block;\r\n  height: 700px;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/Reports/ReportGeneated.css
// module id = ./src/app/Reports/ReportGeneated.css
// module chunks = main